export type ContributionSliceData = {
  label: string;
  value: number;
  pct: number;
  color: string;
  isDeleted?: boolean;
};

export enum ContributionMode {
  TENANT = "tenant",
  CATEGORY = "category",
}
